import React, {Component} from 'react';
import {Tree} from 'antd';
import {queryRoleFunctionFunctionList} from '@api/core/role';
import {queryFunctionListTreeEnable} from '@api/core/function';

const { TreeNode } = Tree;

class SelectFunction extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      checkedKeys: { checked: [], halfChecked: [] },
    };
  }

  componentDidMount() {
    this.loadData().then(() =>
      this.loadChecks(this.props.roleUuid).then(() => this.initCheckedKeys()),
    );
  }

  componentWillReceiveProps(nextProps) {
    this.props.roleUuid !== nextProps.roleUuid &&
      this.loadChecks(nextProps.roleUuid).then(() => this.initCheckedKeys());
  }

  loadData = () => {
    return queryFunctionListTreeEnable().then(res => {
      if (res.statusCode === 200) {
        this.setState({ list: res.data });
      }
    });
  };

  loadChecks = roleUuid => {
    return queryRoleFunctionFunctionList({ roleUuid }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          checkedKeys: {
            checked: res.data.map(item => {
              return item.uuid;
            }),
            halfChecked: [],
          },
        });
      }
    });
  };

  initCheckedKeys = () => {
    const {
      list,
      checkedKeys: { checked },
    } = this.state;

    const { setStateCheckedKeys } = this.props;

    this.handlerCheck(list, checked);
    const newChecked = [];
    const halfChecked = [];
    this.handlerCheckedKeys(list, newChecked, halfChecked);
    const checkedKeys = { checked: newChecked, halfChecked };
    this.setState({
      checkedKeys,
    });
    setStateCheckedKeys(checkedKeys);
  };

  handlerCheck = (list, checked) => {
    return list.map(item => {
      if (checked.includes(item.uuid)) {
        if (item.children && item.children.length > 0) {
          this.handlerCheck(item.children, checked);
          const temp = item.children.filter(item1 => {
            return item1 && item1.isChecked === 0;
          });
          if (temp.length > 0) {
            item.isChecked = 1;
          }
        } else {
          item.isChecked = 2;
        }
      } else {
        item.isChecked = 0;
      }
      return item;
    });
  };

  handlerCheckedKeys = (list, checked, halfChecked) => {
    list.forEach(item => {
      if (item.isChecked === 2) {
        checked.push(item.uuid);
      } else if (item.isChecked === 1) {
        halfChecked.push(item.uuid);
      }
      if (item.children && item.children.length > 0) {
        this.handlerCheckedKeys(item.children, checked, halfChecked);
      }
    });
  };

  onCheck = (checkedKeys, info) => {
    const { setStateCheckedKeys } = this.props;
    const hanldedcheckedKeys = { checked: checkedKeys, halfChecked: info.halfCheckedKeys };
    this.setState({ checkedKeys: hanldedcheckedKeys });
    setStateCheckedKeys(hanldedcheckedKeys);
  };

  renderTreeNodes = data => {
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode title={this.titleItem(item)} key={item.uuid} dataRef={item}>
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return <TreeNode title={this.titleItem(item)} key={item.uuid} dataRef={item} {...item} />;
    });
  };

  titleItem = item => {
    return (
      <span className="treeTitle">
        <span style={{ width: '200px' }}>{item.funName}</span>
      </span>
    );
  };

  render() {
    const { list, checkedKeys } = this.state;
    return (
      <div>
        <Tree checkable onCheck={this.onCheck} checkedKeys={checkedKeys}>
          {this.renderTreeNodes(list || [])}
        </Tree>
      </div>
    );
  }
}

export default SelectFunction;



// WEBPACK FOOTER //
// ./src/components/boss/role/SelectFunction.js